module.exports = "/_next/static/images/projectManagement-6030c55b54cae0ea8299f59fa5b67bf5.webp";